export default __webpack_public_path__ + "static/Logo-receipt-makerly-4fef41116738fa5a1285a4564966f030.png";